module.exports = __webpack_public_path__ + "static/media/googleLogo.04254b4e.svg";